import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VContainer,
    [
      _c("div", { staticClass: "display-1" }, [_vm._v("Videos Help Center")]),
      _c(VBreadcrumbs, {
        staticClass: "pa-0 py-2",
        attrs: { items: _vm.breadcrumbs },
      }),
      _c(
        VRow,
        [
          _c(VCol, { attrs: { cols: "12" } }, [
            _c("iframe", {
              attrs: {
                width: "100%",
                height: "500",
                src: _vm.actualVideo.link,
                frameborder: "0",
              },
            }),
          ]),
          _c(VCol, [
            _c("h1", [_vm._v(_vm._s(_vm.actualVideo.titulo))]),
            _vm._v(_vm._s(_vm.actualVideo.description)),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }